// extracted by mini-css-extract-plugin
export default {"region":"Toast_region__dDEnh","toast":"Toast_toast__bVCW+","icon":"Toast_icon__BbOYx","message":"Toast_message__SDqLo"};